import React from 'react';
import { useNavigate } from 'react-router-dom';
import { a11y } from '../utils/a11yLabels';
import { BackIcon } from './icons';

/**
 * The green back arrow, in two steps.
 *
 *   something typed  →  first press clears it
 *   nothing typed    →  press goes back to Today
 *
 * Silvia's design, and the reason is a small thing that happens constantly: you
 * mistype and want to start the line again. One press hands you a clean box
 * without leaving the screen and coming back to it.
 *
 * `hasText` decides which of the two a press means, and `onClear` does the
 * wiping — the screen owns its own text, this only owns the gesture.
 */
export default function BackClearButton({ hasText, onClear, label }) {
  const navigate = useNavigate();
  const A = a11y(label);
  return (
    <button
      type="button"
      onClick={() => { if (hasText) onClear(); else navigate('/'); }}
      aria-label={A.back}
      title={A.back}
      className="tap-grow"
      style={{
        '--tap-x': '6px',
        width: 38, height: 38, flexShrink: 0, padding: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        borderRadius: '50%', cursor: 'pointer',
        background: 'var(--color-primary)', border: 'none',
        color: '#fff',
      }}
    >
      <span className="rtl-flip" style={{ display: "flex" }}><BackIcon /></span>
    </button>
  );
}
